import { getQueryAsync } from 'api/api-client';
import ErrorDetailsResponse from 'api/models/responses/ErrorDetailsResponse';
import { MutationCache, QueryCache, QueryClient } from 'react-query';
import { toast } from '../index';
import { defaultOptions } from 'hooks/useToast';
import { AppQueryMeta } from 'types';

const getToastTitle = (error: ErrorDetailsResponse) => {
  switch (error.status) {
    case 400:
      return 'Bad operation performed';
    case 404:
      return 'Resource not found';
    default:
      return 'An error occurred';
  }
}

const createToast = (error: ErrorDetailsResponse) => {      
  toast({
    status: 'error',
    ...defaultOptions,
    title: getToastTitle(error),
    description: (error as ErrorDetailsResponse).title,
  });
}

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            queryFn: async ({ queryKey: [endpoint] }) => {
              if (typeof endpoint === 'string') {
                return await getQueryAsync(endpoint);
              }

            },
            staleTime: 30000, // Make queries stale after 30 seconds
            retry: 1
        }
    },
    queryCache: new QueryCache({
      onError: (error, query) => {
        const meta = query.meta as AppQueryMeta | undefined;

        if (!meta?.isErrorHandled) {
          createToast(error as ErrorDetailsResponse);
        }
      },
    }),
    mutationCache: new MutationCache({
    })
  });

export default queryClient;